import styled from 'styled-components';
import { appConfig } from '../../configureApp';

const TrawickTH = styled.td`
  padding: 0.75rem;
  border: 1px solid #e9ecef;
  vertical-align: bottom;
  font-weight: bold;
  background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#031c30'};
  color: ${(props) => (props.color) ? props.color : '#eff0f3'};
`;

const SCTITH = styled.th`
    background: #F7F7F7;
    padding: 10px;
    text-align: left;
    font-family: 'Omnes';
    font-size: 16px;
    font-weight: 500;
    color: #4A4A4A;
`;

const TH = appConfig.reactAppEnv === 'scti' ? SCTITH : TrawickTH;

export default TH;



// WEBPACK FOOTER //
// ./app/components/Table/TH.js